import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import main from './main';
import mMain from './mMain';
import logreg from './js/logreg';
import api from './js/api';

// eslint-disable-next-line no-mixed-operators
var getRegV = function getRegV(key) {
  return window.baseAxios && window.baseAxios.loginReg && window.baseAxios.loginReg[key] || '';
};
export default {
  name: 'wrap',
  props: {
    baseUrl: {
      type: String,
      default: function _default() {
        return getRegV('baseUrl');
      }
    },
    thirdHost: {
      type: String,
      default: function _default() {
        return getRegV('thirdHost');
      }
    },
    oldThirdHost: {
      type: String,
      default: function _default() {
        return getRegV('oldThirdHost');
      }
    },
    clientId: {
      type: String,
      default: function _default() {
        return getRegV('clientId');
      }
    },
    client_secret: {
      type: String,
      default: function _default() {
        return getRegV('client_secret');
      }
    },
    business: {
      type: String,
      default: function _default() {
        return getRegV('business');
      }
    },
    redirect_uri: {
      type: String,
      default: function _default() {
        return getRegV('redirect_uri');
      }
    },
    alias: {
      type: String,
      default: function _default() {
        return getRegV('alias');
      }
    },
    logout: {
      type: Function,
      default: function _default() {}
    },
    success: {
      type: Function,
      default: function _default() {}
    },
    fail: {
      type: Function,
      default: function _default() {}
    },
    // code.vue 人机验证多语言
    codePlaceholder: {
      type: String,
      default: 'userSign.inputCode'
    }
  },
  components: {
    'main-pc': main,
    'main-m': mMain
  },
  data: function data() {
    return {
      showWrap: false,
      showState: false,
      showContent: false
    };
  },
  methods: {
    closeHandle: function closeHandle() {
      this.closeFrame();
    },
    showFrame: function showFrame() {
      this.showState = true;
    },
    closeFrame: function closeFrame() {
      this.showState = false;
    },
    logoutAction: function logoutAction() {
      logreg.logoutAction(this.logout);
    },
    isLogined: function isLogined() {
      return logreg.isLogined();
    },
    getUserInfo: function getUserInfo() {
      return logreg.getUserInfo();
    }
  },
  watch: {
    showState: function showState(val) {
      var _this = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              if (val) {
                document.documentElement.style.overflow = 'hidden';
                _this.showWrap = true;
                setTimeout(function () {
                  _this.showContent = true;
                }, 10);
              } else {
                document.documentElement.style.overflow = 'auto';
                _this.showContent = false;
                setTimeout(function () {
                  _this.showWrap = false;
                }, 300);
              }
            case 1:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }))();
    }
  },
  created: function created() {
    api.init(this.baseUrl, this.business, this.redirect_uri, this.alias);
  },
  mounted: function mounted() {
    var _this2 = this;
    window.errorMessageLoginTip = window.errorMessageTMX && Object.keys(window.errorMessageTMX);
    logreg.loginAction(function (state, data) {
      _this2.success(data);
    });
  },
  beforeDestroy: function beforeDestroy() {}
};